export const parseLocationSearch = (x: string): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const params = new URLSearchParams(window.location.search);
  return params.get(x);
};

// Has the user requested an in development feature via URL param (`?feature=true`)?
const hasRequestedFeature = (feature: string) => {
  const featureInLocation = parseLocationSearch(feature);
  return featureInLocation === 'true';
};

/**
 * Check for the value in local storage and also set/reset it according to query param
 *
 * @param feature - string to check in url and localstorage
 * @returns boolean - either whether the query param or local storage is true
 */
const checkAndSetLocalStorage = (feature: string): boolean => {
  // First grab the query param:
  const queryParam = parseLocationSearch(feature);
  // If we have something, set local storage and then return if it's true
  if (queryParam) {
    // Remove key and return false if query's false:
    if (queryParam === 'false') {
      try {
        window.localStorage.removeItem(feature);
      } catch (error) {}
      return false;
    }
    try {
      window.localStorage.setItem(feature, JSON.stringify(queryParam));
    } catch (error) {}
    return queryParam === 'true';
  }
  // No query param?  Check local storage:
  try {
    const item = window.localStorage.getItem(feature);
    return item ? JSON.parse(item) === 'true' : false;
  } catch (error) {}
  return false;
};

// Have they enabled feature flag either through URL or localStorage?
/**
 *
 * @param feature string - feature name as passed to URL param (or set in LocalStorage)
 * @param checkLocalStorage - boolean (default false) whether we should check and set local storage
 * @returns boolean - store the return value as a const and check it to show/hide UI, etc.
 */
export const shouldShowInDevelopmentFeature = (
  feature: string,
  checkLocalStorage = false,
): boolean => {
  if (checkLocalStorage) {
    return checkAndSetLocalStorage(feature);
  }
  return hasRequestedFeature(feature);
};
